import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../Redux/store";
import IndexBase from "../../../../../Components/IndexApp";
import Layout from "../../../../../Components/LayoutApp";
import PunctualCourseRepository from "../../../../../Repositories/PunctualCourseRepository";
import { PunctualCourseDashboard } from "../../../../../Objects/models/PunctualCourseDashboard";
import { useQuery } from "@tanstack/react-query";
import {
  DataButton,
  TheadItem,
} from "../../../../../Objects/interfaces/AppInterface";
import MenuBookTwoToneIcon from "@mui/icons-material/MenuBookTwoTone";
import PendingActionsSharpIcon from "@mui/icons-material/PendingActionsSharp";
import RestoreSharpIcon from "@mui/icons-material/RestoreSharp";
import UserCourses from "../../UserCourses";
import { useNavigate } from "react-router-dom";
import TableLayout from "../../../../../Components/Table/TableLayout";
import NavigationLayout from "../../../../../Components/shared/NavigationLayout";
import { srcHistoric, srcNoCourse } from "../../../../../Utils/Images";
// import HistoricCourses from "../../../../Teacher/Admin/Dashboard/Courses/Historic/HistoricCourses";

const tabsValue = ["taken", "pending", "historic", "urgent"] as const;
type TabsValueType = (typeof tabsValue)[number];

const DashboardClient = () => {
  // const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<TabsValueType>("pending");
  const [activeRow, setActiveRow] = useState<number | null>(null);
  const [loadData, setLoadData] = useState(false);

  const currentClient = useSelector(
    (state: RootState) => state.user?.currentUser.client
  );

  const loggedUserId = currentClient?.id;

  const {
    data: ponctualCourseList,
    isLoading: isLoadingCourses,
    refetch: refetchCourses,
  } = useQuery({
    queryKey: [loggedUserId, "punctual-courses"],
    queryFn: () =>
      PunctualCourseRepository.getPendingPunctualCourse(loggedUserId!).then(
        (courses) =>
          courses.reduce(
            (
              acc: [PunctualCourseDashboard[], PunctualCourseDashboard[]],
              course: PunctualCourseDashboard
            ) => {
              if (course.directAskedTeachr) {
                acc[0].push(course); // taken
              } else {
                acc[1].push(course); // pending
              }
              return acc;
            },
            [[], []]
          )
      ),
    enabled: !!loggedUserId,
  });

  const { data: pastPonctualCourseList, isLoading: isLoadingPastCourses } =
    useQuery({
      queryKey: [loggedUserId, "past-punctual-courses"],
      queryFn: () =>
        PunctualCourseRepository.getPastPunctualCourse(loggedUserId!),
      enabled: !!loggedUserId,
    });

  const { data: upcomingCourses } = useQuery({
    queryKey: [loggedUserId, "upcoming-punctual-courses"],
    queryFn: () =>
      PunctualCourseRepository.getActivePunctualCourse(loggedUserId!),
    enabled: !!loggedUserId,
  });

  let coursesToDisplay = (
    activeTab === "taken"
      ? upcomingCourses || []
      : activeTab === "pending"
        ? ponctualCourseList
          ? ponctualCourseList[1]
          : []
        : activeTab === "historic"
          ? pastPonctualCourseList || []
          : []
  ).sort(
    (a, b) => (b.isCourseInTheHour ? 1 : 0) - (a.isCourseInTheHour ? 1 : 0)
  );

  const dataBtn1: DataButton[] = [
    {
      value: 1,
      handleChange: () => navigate("/user/dashboard/declare"),
      icon: MenuBookTwoToneIcon,
      title: "📚 Faire une demande de cours",
      classCustom: "lg:px-10",
      id: ""
    },
  ];

  const dataTheadShow: TheadItem[] = [
    { title: "Dates des cours ", classThead: "" },
    { title: "Heure prévue ", classThead: "" },
    { title: "Durée ", classThead: "" },
    { title: "Matière", classThead: "" },
    { title: "Statut ", classThead: "" },
    { title: "Type des cours", classThead: "" },
    { title: "Format des cours", classThead: "" },
    { title: "Actions", classThead: "sticky right-0 z-10 bg-inherit" },
  ];

  const dataBtn2: DataButton[] = [
    {
      value: 1,
      handleChange: () => setActiveTab("pending"),
      icon: PendingActionsSharpIcon,
      title: "📆 Cours prévus",
      // classCustom: `${props.currentPage === 2 || props.currentPage === 0 ? 'hidden' : props.component === 1 ? 'lg:text-white lg:bg-first lg:opacity-90' : 'lg:text-first /lg:bg-white hover:bg-gray-100'}`
      classCustom: activeTab === "taken" || activeTab === "pending"
        ? "lg:text-white lg:bg-first lg:opacity-90"
        : "lg:text-first /lg:bg-white hover:bg-gray-100",
      id: ""
    },
    {
      value: 2,
      handleChange: () => setActiveTab("historic"),
      icon: RestoreSharpIcon,
      title: " 📜 Historique des cours",
      // classCustom: `${props.currentPage === 2 || props.currentPage === 0 ? 'hidden' : props.component === 2 ? 'lg:text-white lg:bg-first lg:opacity-90' : 'lg:text-first /lg:bg-white hover:bg-gray-100'}`,
      classCustom: activeTab === "historic"
        ? "lg:text-white lg:bg-first lg:opacity-90"
        : "lg:text-first /lg:bg-white hover:bg-gray-100",
      id: ""
    },
  ];

  const toggleRow = (index: number) =>
    setActiveRow(activeRow === index ? null : index);

  const headerNavigation = () => {
    if (activeTab === "historic") return null;
    return (
      <div className="flex flex-col space-y-3 lg:flex-row lg:items-center lg:justify-between lg:space-y-0 lg:space-x-4 -mt-4 lg:-mt-0 ">
        <div className="flex flex-col-reverse gap-y-4 flex-shrink-0 md:flex-row md:items-center gap-x-3 w-full">
          <div className="md:w-3/5 flex flex-col lg:flex-row md:space-y-0 /md:space-x-3 w-full space-y-3 lg:justify-end ">
            <div className="flex w-full border-first border rounded-full shadow-md">
              <button
                onClick={() => setActiveTab("taken")}
                type="button"
                className={`flex items-center justify-center flex-1 flex-shrink-0 px-3 py-1 lg:text-lg md:text-base text-sm font-bold borde rounded-full ${activeTab === "taken"
                  ? "text-white bg-first shadow-md"
                  : "text-first bg-white"
                  }`}
              >
                📅 Cours à venir
              </button>
              <button
                onClick={() => setActiveTab("pending")}
                type="button"
                className={`flex items-center justify-center flex-1 flex-shrink-0 px-3 py-1 lg:text-lg md:text-base text-sm font-bold borde rounded-full ${activeTab === "pending"
                  ? "text-white bg-first shadow-md"
                  : "text-first bg-white"
                  }`}
              >
                🔍 Cours en attente d'un professeur
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <IndexBase
      index={9}
      component={
        <Layout>
          <NavigationLayout dataBtn1={dataBtn1} dataBtn2={dataBtn2} />
          {/* <p>Vous êtes : {currentClient?.firstName} {currentClient?.lastName}. ID Utilisateur : {currentClient?.id}</p>    */}
          {isLoadingCourses ? (
            <p>Chargement de votre liste de cours...</p>
          ) : (
            <div>
              {activeTab === "historic" ? (
                isLoadingPastCourses ? (
                  <p>Chargement de votre historique de cours...</p>
                ) : (
                  <TableLayout
                    header={headerNavigation()}
                    data={coursesToDisplay}
                    dataThead={dataTheadShow}
                    message={
                      coursesToDisplay?.length === 0
                        ? "Pour le moment, aucun historique de cours n’est disponible. Une fois que vous aurez commencé à déclarer vos cours, vous pourrez consulter ici l’ensemble des activités déjà enregistrées. N’hésitez pas à ajouter vos cours pour enrichir votre historique et suivre facilement vos sessions passées !"
                        : "Pour le moment, aucun historique de cours n’est disponible. Une fois que vous aurez commencé à déclarer vos cours, vous pourrez consulter ici l’ensemble des activités déjà enregistrées. N’hésitez pas à ajouter vos cours pour enrichir votre historique et suivre facilement vos sessions passées !"
                    }
                    bgImg={srcHistoric}
                    component={pastPonctualCourseList?.map(
                      (punctual: PunctualCourseDashboard, key: number) => (
                        <React.Fragment key={key}>
                          <UserCourses
                            activeTab={activeTab}
                            isCoursePass={true}
                            // punctual={punctual}
                            punctual={
                              activeTab === "historic"
                                ? { ...punctual, pastPonctualCourseList: true }
                                : punctual
                            }
                            teachr={currentClient}
                            key={key}
                            toggleRow={toggleRow}
                            activeRow={activeRow}
                            load={loadData}
                            setLoad={setLoadData}
                            refetchCourses={refetchCourses}
                          // dataDispatch={dataDispatch}
                          />
                        </React.Fragment>
                      )
                    )}
                  />
                )
              ) : (
                <TableLayout
                  header={headerNavigation()}
                  data={coursesToDisplay}
                  dataThead={dataTheadShow}
                  bgImg={srcNoCourse}
                  message={
                    coursesToDisplay?.length === 0
                      ? "Pour réserver votre premier cours, il vous suffit de parcourir les offres et de choisir le cours qui vous convient le mieux. Cette étape vous permettra de vous connecter avec le bon enseignant et d’assurer une expérience d’apprentissage fluide et organisée. N’attendez plus, commencez dès maintenant et réservez votre premier cours !"
                      : "Pour réserver votre premier cours, il vous suffit de parcourir les offres et de choisir le cours qui vous convient le mieux. Cette étape vous permettra de vous connecter avec le bon enseignant et d’assurer une expérience d’apprentissage fluide et organisée. N’attendez plus, commencez dès maintenant et réservez votre premier cours !"
                  }
                  component={coursesToDisplay?.map(
                    (punctual: PunctualCourseDashboard, key: number) => (
                      <React.Fragment key={key}>
                        <UserCourses
                          activeTab={activeTab}
                          isCoursePass={true}
                          // punctual={{ ...punctual, upcomingCourses: true }}
                          punctual={
                            activeTab === "taken"
                              ? { ...punctual, upcomingCourses: true }
                              : punctual
                          }
                          teachr={currentClient}
                          key={key}
                          toggleRow={toggleRow}
                          activeRow={activeRow}
                          load={loadData}
                          setLoad={setLoadData}
                          refetchCourses={refetchCourses}
                        // dataDispatch={dataDispatch}
                        />
                      </React.Fragment>
                    )
                  )}
                />
              )}
            </div>
          )}
        </Layout>
      }
      teachr={currentClient}
    />
  );
};

export default DashboardClient;
